export default "__VITE_ASSET__5843GMNE__"